module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "button-bar"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.newProject
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Project")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "well"
  }, [_c('h3', [_vm._v("Filter Projects")]), _vm._v(" "), _c('button-group', {
    attrs: {
      "vertical": "true",
      "buttons": _vm.projectFilter.buttons,
      "full-width": true
    },
    on: {
      "change": _vm.getProjects
    },
    model: {
      value: (_vm.projectFilter.value),
      callback: function($$v) {
        _vm.projectFilter.value = $$v
      },
      expression: "projectFilter.value"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('h2', [_vm._v("Projects")]), _vm._v(" "), _vm._l((_vm.mutatedProjects), function(project) {
    return _c('router-link', {
      key: project.id,
      staticClass: "project-link",
      attrs: {
        "to": '/projects/' + project.id + '/tasks'
      }
    }, [_c('div', {
      staticClass: "panel panel-default project"
    }, [_c('div', {
      staticClass: "panel-body"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "well"
    }, [_c('table', {
      staticClass: "table"
    }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Status:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(project.archived == 1 ? 'Archived' : 'Active'))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Current Phase:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(project.currentPhase))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Date Created:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(project.created_at))])]), _vm._v(" "), (project.project_lead_id != 0) ? _c('tr', [_c('th', [_vm._v("Project Lead:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(project.users ? project.users.first_name : '') + " " + _vm._s(project.users ? project.users.last_name : ''))])]) : _vm._e(), _vm._v(" "), (project.phases) ? _c('tr', [_c('th', [_vm._v("Current Phase:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(project.currentPhase))])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [_c('h3', [_vm._v(_vm._s(project.project_name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(project.description))])])])])])])
  })], 2)]), _vm._v(" "), (_vm.projectDialog.visible) ? _c('modal-dialog', {
    attrs: {
      "title": _vm.projectDialog.title,
      "modal-visible": _vm.projectDialog.visible,
      "confirm-button-text": "Save",
      "button-class": "btn-success"
    },
    on: {
      "confirm": _vm.saveProject,
      "closeModal": function($event) {
        _vm.projectDialog.visible = false
      }
    }
  }, [_c('form-group', {
    attrs: {
      "label": "Project Name",
      "col-class": "col-md-4"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projectDialog.values.project_name),
      expression: "projectDialog.values.project_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.projectDialog.values.project_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.projectDialog.values.project_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Project Description",
      "col-class": "col-md-4"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projectDialog.values.description),
      expression: "projectDialog.values.description"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.projectDialog.values.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.projectDialog.values.description = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Project Lead",
      "col-class": "col-md-4"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projectDialog.values.project_lead_id),
      expression: "projectDialog.values.project_lead_id"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.projectDialog.values.project_lead_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.$root.users), function(user) {
    return _c('option', {
      domProps: {
        "value": user.id
      }
    }, [_vm._v(_vm._s(user.first_name) + " " + _vm._s(user.last_name))])
  }))])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13f3655f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Projects.vue
// module id = 268
// module chunks = 0